<template>
  <div class="home m-viewport">
    <div class="cover root-cover" :class="{ 'fade' : headerFixed }">
        <div class="cover-img" :class="{ 'fade' : headerFixed }"></div>
        <!-- <div class="main-title" :class="{ 'fade' : headerFixed }"></div> -->
        <div class="video_bgbox" :class="{ 'fade' : headerFixed }">
          <video src="//web-resource.17m3.com/m3guo/202207/version/cover.mp4" class="video" autoplay="" loop="" muted=""></video>
        </div>

        <h1 class="logo" :class="{ 'fade' : headerFixed }"><a href="https://www.m3guo.com/v2/" target="_blank"></a></h1>

        <div class="u-top" :class="{ 'fade' : headerFixed }">
            <div class="link-item">
            <a href="https://www.m3guo.com/v2/" target="_blank" class="u-btn game-web"></a>
            </div>
            <div class="link-item">
            <a href="https://www.m3guo.com/v2/download/client/" target="_blank" class="u-btn game-dl"></a>
            </div>
        </div>

        <div class="icon-md" :class="{ 'fade' : headerFixed }">
            <div class="layer-md"></div>
            <div class="icon-arrow"></div>
        </div>
    </div>

    <div class="m-main-view">
        <riddle :login="login" :ua="ua" :evt_info="evt_info"/>
        <hero/>
        <update/>
    </div>

    <item-tips ref="tips"></item-tips> 
  </div>
</template>

<style scoped>
/* .m-viewport{
    width: 100%;
    min-height: 3955px;
    padding-top: 400px;
    padding-bottom: 200px;
    background-image: url(~@/assets/images/pc/bottom.jpg);
    background-attachment: local;
    background-color: #0a0a0c;
    background-repeat: no-repeat;
    background-size: cover;        
    background-position: bottom center;
} */

.m-viewport{
    max-width: 1920px;
    height: 5200px;
    /* padding-top: 400px;
    padding-bottom: 200px; */
    margin: 0 auto;
    background-image: url(~@/assets/images/pc/body.jpg);
    background-color: #0a0a0c;
    background-repeat: no-repeat;       
    background-position: top center;
}

.icon-md{
    position: absolute;
    left: 50%;
    bottom: 40px;
    transform: translateX(-50%);
    z-index: 16;
}

.icon-md.fade{
    display: none;
}

.icon-md .layer-md{
    width: 112px;
    height: 48px;
    margin-bottom: 20px;
    background-image: url(~@/assets/images/pc/icon-md.png);
}

.icon-md .icon-arrow{
  width: 34px;
  height: 18px;
  margin: 0 auto;
  background-image: url(~@/assets/images/pc/icon-arrow.png);
  animation:arrowLLoop 4s linear infinite
}

@-webkit-keyframes arrowLLoop {
  0% {-webkit-transform:translateY(0);opacity: 1;}
  50% {-webkit-transform:translateY(-20px);opacity: 0;}
  to {-webkit-transform:translateY(0);opacity: 1;}
}

.logo{
  position: absolute;
  top: 60px;
  left: 2%;
  width: 124px;
  height: 98px;
  background-image: url(~@/assets/images/pc/logo.png);
  z-index: 16;
}

.logo.fade{
    display: none;
}

.logo a{
  display: block;
  width: 100%;
  height: 100%;
}

.u-top{
    position: absolute;
    top: 80px;
    right: 2%;
    width: 204px;
    height: 28px;
    background-image: url(~@/assets/images/pc/btn-top.png);
    z-index: 16;    
}

.u-top.fade{
    display: none;
}

.u-top .link-item{
    float: left;
    width: 50%;
    height: 28px;
}

.link-item a{
  display: block;
  width: 100%;
  height: 100%;    
}

.video_bgbox {
    width: 1920px;
    height: 1060px;
	position: absolute;
	left: 50%;
	top: 0;
	z-index: 15;
	transform: translateX(-50%);
	pointer-events: none;
    overflow: hidden;
}

.video_bgbox.fade{
    display: none;
}

.video {
    width: 1920px;
    height: 1080px;
	position: relative;
	top: 0;
}

.video.fade{
    display: none;
}

.root-cover{
    position: relative;
    max-width: 1920px;
    height: 1080px;
    margin: 0 auto;
    /* pointer-events: none; */
    z-index: 10; 
}

.root-cover.fade{
    pointer-events: none;
}

/* .cover-img{
    position: absolute;
    height: calc(100% + 42px);
    left: 0;
    top: 0;
    width: calc(100% + 42px);
    background-image: url(~@/assets/images/pc/cover.jpg);
    background-attachment: local;
    background-color: #0a0a0c;
    background-repeat: no-repeat;
    background-size: cover;        
    background-position: top center;
    opacity: 1;
    transition: opacity .5s;   
}

.cover-img.fade{
    opacity: 0!important;
    pointer-events: none;
}

.main-title{
    position: absolute;
    left: 50%;
    top: 50%;
    width: 833px;
    height: 309px;
    margin-left: -416.5px;
    background-image: url(~@/assets/images/pc/main-title.png);
    transition: opacity .5s,transform .5s;
    pointer-events: none;  
}

.main-title.fade{
    opacity: 0;
    transform: translateY(-100px);
    transition-timing-function: ease-in;
} */

.m-main-view{
    padding-top: 50px;
}
</style>

<script>
import riddle from '@/components/page/riddle'
import hero from '@/components/page/hero'
import update from '@/components/page/update'

export default {
    components: {
        riddle,
        hero,
        update,
    },    
    data (){
        return {
            headerFixed : false,
        }
    },
    props : {
        ready : {
            default : false,
        },
        login : {
            default : 0,
        },      
        ua : {
            default : () => [],
        },
        evt_info : {
            default : () => [],
        }, 
        time : {
            default : 0,
        }                           
    },      
    mounted() {
        let _this = this;

        // _this.$nextTick(function () {
        //     window.addEventListener('scroll', this.handleScroll)
        // })          
    },
    props : {
        ready : {
            default : false,
        },
        login : {
            default : 0,
        },      
        ua : {
            default : () => [],
        },
        evt_info : {
            default : () => [],
        },                            
    },        
    methods: {
        handleScroll() {
            let _this = this;
            let scrollTop = window.pageYOffset ||document.documentElement.scrollTop ||document.body.scrollTop;
            _this.headerFixed = scrollTop > 0

            // var result = collectActiveNav();
            // _this.currentPage = typeof result[0] != 'undefined'? result[0] : -1;
            // console.log(_this.currentPage);

            function collectActiveNav(){
                var ret = [] ;

                let body_item = document.querySelectorAll('.page-item');

                for (var i = 0; i < body_item.length; i++) {
                    let ele = body_item[i];
                    if (inViewport(i,0,ele)){
                        ret.push(i);
                    }                    
                } 
                return ret;
            };

            function inViewport(i, delta,ele){
                var top = _this.item_posY[i];
                
                delta = delta || 0;
                
                return top - delta + ele.offsetHeight > scrollTop && top - delta < scrollTop + document.documentElement.clientHeight;
            };           
            
        },
        computed_posY(){
          let _this = this;
          let items = document.querySelectorAll('.page-item');
          items.forEach((el) => {
            _this.item_posY.push(el.offsetTop);
          })
        },      
    },          
}
</script>


// WEBPACK FOOTER //
// src/view/index/index.vue